export const PORTFOLIO_COMPOSITION = "PORTFOLIO_COMPOSITION";
export const PORTFOLIO_COMPOSITION_ERROR = "PORTFOLIO_COMPOSITION_ERROR";
export const PORTFOLIO_COMPOSITION_HIDE_ERROR = "PORTFOLIO_COMPOSITION_HIDE_ERROR";
export const PORTFOLIO_COMPOSITION_START_LOADER = "PORTFOLIO_COMPOSITION_START_LOADER";
export const PORTFOLIO_COMPOSITION_STOP_LOADER = "PORTFOLIO_COMPOSITION_STOP_LOADER";
